import React from 'react';
import { Link } from 'react-router-dom';

import { NewsPage, NewsContainer, NewsHeader } from './NewsElements';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

import { useLanguage } from '../../../hooks';

import { MainPageText } from '../../Library/LibraryMainPage';
import news1 from '../../../img/news/news1.jpg';
import news2 from '../../../img/news/news2.png';
import news3 from '../../../img/news/news3.jpg';

const NewsSection = () => {
  const { lang } = useLanguage();

  const textData = MainPageText[lang];

  const newsList = [
    {
      id: 1,
      image: news1,
      text: textData.news1,
      link: '/news1',
    },
    {
      id: 2,
      image: news2,
      text: textData.news2,
      link: '/news2',
    },
    {
      id: 3,
      image: news3,
      text: textData.news3,
      link: '/news3',
    },
  ];

  return (
    <NewsPage id="news">
      <NewsContainer>
        <NewsHeader>{textData.news}</NewsHeader>

        <List sx={{ width: '100%', maxWidth: 600, margin: '2em 0' }}>
          {newsList.map((item) => (
            <Link key={item.id} to={item.link} style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItem
                alignItems="flex-start"
                sx={{
                  marginBottom: '20px',
                  backgroundColor: 'rgba(255,255,255,0.5)',
                  borderRadius: '10px',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.02)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                  },
                }}
              >
                <ListItemAvatar>
                  <Avatar
                    src={item.image}
                    alt="news image"
                    variant="rounded"
                    sx={{
                      width: 200,
                      height: 130,
                      marginRight: '15px',
                    }}
                  />
                </ListItemAvatar>

                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    style: {
                      fontWeight: '500',
                      color: '#333',
                      fontSize: '14px',
                      lineHeight: '1.4',
                    },
                  }}
                />
              </ListItem>
            </Link>
          ))}
        </List>
      </NewsContainer>
    </NewsPage>
  );
};

export default NewsSection;
